export enum ECompanionCommunicationType {
  Alternate = 0,
  Random = 1,
}


